import { render, staticRenderFns } from "./aftermarket.vue?vue&type=template&id=2bfc2409&scoped=true"
import script from "./aftermarket.vue?vue&type=script&lang=js"
export * from "./aftermarket.vue?vue&type=script&lang=js"
import style0 from "./aftermarket.vue?vue&type=style&index=0&id=2bfc2409&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bfc2409",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bfc2409')) {
      api.createRecord('2bfc2409', component.options)
    } else {
      api.reload('2bfc2409', component.options)
    }
    module.hot.accept("./aftermarket.vue?vue&type=template&id=2bfc2409&scoped=true", function () {
      api.rerender('2bfc2409', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/shopManage/components/aftermarket.vue"
export default component.exports